import { LucideIcon } from 'lucide-react'
import { cn } from '@/lib/utils'

interface StatCardProps {
    title: string
    value: string | number
    icon: LucideIcon
    trend?: {
        value: string
        type: 'up' | 'down' | 'neutral'
    }
    iconBgColor?: string
    iconColor?: string
    className?: string
    onClick?: () => void
}

export function StatCard({
    title,
    value,
    icon: Icon,
    trend,
    iconBgColor = 'bg-blue-100 dark:bg-blue-900/30',
    iconColor = 'text-primary dark:text-blue-300',
    className,
    onClick
}: StatCardProps) {
    return (
        <div
            onClick={onClick}
            className={cn(
                "bg-card p-5 rounded-xl shadow-sm border border-border",
                "flex items-center justify-between",
                "hover:shadow-md transition-shadow cursor-pointer",
                className
            )}
        >
            <div className="space-y-1">
                <p className="text-muted-foreground text-xs font-medium">{title}</p>
                <h3 className="text-2xl font-bold text-foreground">{value}</h3>
                {trend && (
                    <span className={cn(
                        "text-xs flex items-center gap-1",
                        trend.type === 'up' && "text-green-500",
                        trend.type === 'down' && "text-red-500",
                        trend.type === 'neutral' && "text-muted-foreground"
                    )}>
                        {trend.type === 'up' && (
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
                            </svg>
                        )}
                        {trend.type === 'down' && (
                            <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
                            </svg>
                        )}
                        {trend.value}
                    </span>
                )}
            </div>
            <div className={cn(
                "w-12 h-12 rounded-lg flex items-center justify-center",
                iconBgColor
            )}>
                <Icon className={cn("h-6 w-6", iconColor)} />
            </div>
        </div>
    )
}
